import { I18n } from 'aws-amplify';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SelectButton } from 'primereact/selectbutton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalHelpState } from '../../../help-context';
import { getInformations } from '../../../service/ScrbService';
import { Help } from '../../help/Help';
import Contacts from './Contacts';
import Outils from './Outils';
import Pricing from './Pricing';
import Reglements from './Reglements';
import Infos from './Infos';

export const Informations = () => {

    const [informations, setInformations] = useState(null);
    const toast = useRef(null);
    const help = useGlobalHelpState();

    const options = [
        { label: I18n.get("contacts"), value: 1, icon: "fa-light fa-address-book" },
        { label: I18n.get("prixPratique"), value: 2, icon: "fa-light fa-euro" },
        { label: I18n.get("reglements"), value: 3, icon: "fa-light fa-file-contract" },
        { label: I18n.get("outils"), value: 4, icon: "fa-light fa-wrench" },
        { label: I18n.get("informations"), value: 5, icon: "fa-light fa-circle-info" }
    ]
    const [selectedOption, setSelectedOption] = useState(1);

    useEffect(() => {
        getInformations(1).then(informations => {
            setInformations(informations[0]);
        });
        help.set({ help: Help.informations, show: false });
        //eslint-disable-next-line
    }, []);

    const showNotif = (severity, summary, detail) => {
        toast.current?.show({
            severity: `${severity}`,
            summary: `${summary}`,
            detail: `${detail}`,
            life: 3000
        });
    }

    const itemTemplate = (option) => {
        return <span className="flex flex-row w-full lg:w-10rem lg:w-10rem align-items-center justify-content-center" >
            <i className={option.icon} style={{ fontSize: "1.5rem" }}></i>
            <span className="pl-2">{option.label}</span>
        </span>;
    }

    return informations ? (
        <>
            <Toast ref={toast} />
            <div className="card">
                <h5>{I18n.get("welcome")}</h5>
                <SelectButton
                    value={selectedOption}
                    options={options}
                    onChange={(e) => setSelectedOption(e.value)}
                    itemTemplate={itemTemplate}
                    className="pb-3 p-selectbutton-infos w-full"
                    allowEmpty={false}
                />
                {selectedOption === 1 && <Contacts informations={informations} showNotif={showNotif} />}
                {selectedOption === 2 && <Pricing informations={informations} />}
                {selectedOption === 3 && <Reglements />}
                {selectedOption === 4 && <Outils />}
                {selectedOption === 5 && <Infos informations={informations} />}
            </div>
        </>
    ) : (
        <ProgressSpinner className="flex justify-center" />
    );
}